import { ActionIcon, Menu, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { POIFilter } from 'app/modules/wallforming/components/scenes/toolbar/content/POIFilter';

import type { Dispatch, SetStateAction } from 'react';

interface PoiFilterButtonProps {
    menuOpened: boolean;
    setMenuOpened: Dispatch<SetStateAction<boolean>>;
}

const screenWidth = window.screen.width;

export const PoiFilterButton = ({ menuOpened, setMenuOpened }: PoiFilterButtonProps) => {
    const { t } = useTranslation();

    return (
        <Menu
            closeOnItemClick={false}
            offset={4}
            opened={menuOpened}
            position="right-start"
            shadow="md"
            withinPortal
            onChange={setMenuOpened}
        >
            <Menu.Target>
                <Tooltip label={t('labelPoiTypeFilter')} position="right" variant={variants.tooltip.right}>
                    <ActionIcon
                        className={`
                            bg-background-gray-ultra-light hover:bg-background-gray!
                            ${screenWidth >= 1920 ? 'action-icon-large' : 'action-icon-medium'}
                        `}
                        size="lg"
                        variant={menuOpened ? variants.actionIcon.activated : undefined}
                    >
                        filter_alt
                    </ActionIcon>
                </Tooltip>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label className="min-w-60">{t('labelPoiTypeFilter')}</Menu.Label>
                <Menu.Divider />
                <POIFilter />
            </Menu.Dropdown>
        </Menu>
    );
};
